import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { guiaColumnasFijas } from "app/features/general/operativa/items/guias";

type Entity = models.GuiaDTO;
export interface Deps {
    onVer: (x: Entity) => void;
    onQuitar: (x: Entity) => void;
}
export function columnas(deps: Deps) {
    const ret: kea.Grid2Column<Entity>[] = [
        kea.columnaBotones([
            {
                iconClass: fa("eye"),
                onClick: deps.onVer,
                tooltip: "Ver detalle"
            }, {
                iconClass: fa("trash"),
                onClick: deps.onQuitar,
                tooltip: "Quitar guia"
            }
        ]),
        ...guiaColumnasFijas
    ];
    return ret;
}


interface Props {
    value: models.GuiaDTO[];
    onQuitarGuia: (x: Entity) => void | Promise<void>;
}
  class GuiasEnCargaDescargaNoRx extends React.PureComponent<Props> {
    onVer = (guia: models.GuiaDTO) => {
        history.go("/operativa/guias/" + guia.Folio);
    }

    onQuitar = async (x: Entity) => {
        if(await kea.yesno("Quitar guia", `¿Quitar guia ${x.Folio}?`)){
            await this.props.onQuitarGuia(x); 
        }
    }

    render() {
        const cols = columnas(this);
        return (
            <div>
                <kea.Grid2 cookieKey="multiselectorGuia" items={this.props.value} columnas={cols} hideBusqueda={true} />
            </div>
        )
    }
}

export const GuiasEnCargaDescarga = componentToRx(GuiasEnCargaDescargaNoRx);


// WEBPACK FOOTER //
// ./app/features/componentes/cargas/guiascarga.tsx